import React from "react";

export const HomePage = () => {

  return (
      <>

          <div className="container-page">

              <div className="container-relative">

              </div>
          </div>

      </>
  );
}
